import gql from 'graphql-tag';
const HIGHLIGHT_IT_ACTIVITY_FRAGMENT = gql `
  fragment HighlightItActivityFragment on HighlightItActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
      }
    }
    rounds {
      id
      numAnswers
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
        }
      }
      hint {
        id
        audioId
        audio {
          id
          src
        }
      }
      mainContent {
        id
        svgId
        svg {
          id
          src
        }
      }
      questionHtml {
        id
        elements
      }
    }
  }
`;
export default HIGHLIGHT_IT_ACTIVITY_FRAGMENT;
